import React, {useEffect, useState} from 'react';
import {Card, CardBody, CardTitle, Collapse} from 'reactstrap';

import {
    ARE_YOU_SHURE_MSG,
    ARE_YOU_SHURE_TITLE,
    deleteErrorMsg,
    deleteMsg,
    error,
    LIST,
    NO, NO_DATA_FOUND,
    warning,
    YES
} from "../../../components/i18n/i18n";
import {confirmAlert} from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {
    ButtonTableFilter,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showLoader} from "../../../components/loader/loader";
import {showToastCustom} from "../../../components/toast/customToast";
import {utilHelper} from "../../../jwt/_helpers";
import SalesPackageFilters from "./_filters";
import {salesPackageService} from "../../../jwt/_services/promotions/salesPackageService";
import {TT_DELETE, TT_EDIT} from "../../../components/i18n/toolTips";

export default function SalesPackageList(props) {

    const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
    const [sizePerPage, setSizePerPage]         = useState(props.listState !== undefined && props.listState !== null ? props.listState.sizePerPage : 10 );
    const [page, setPage]                       = useState(props.listState !== undefined && props.listState !== null ? props.listState.page : 1 );
    const [currentIndex, setCurrentIndex]       = useState(props.listState !== undefined && props.listState !== null ? props.listState.currentIndex : 0);
    const [totalSize, setTotalSize]             = useState(props.listState !== undefined && props.listState !== null ? props.listState.totalSize : 10 );
    const [loading, setLoading] = useState(false);
    const [listItems, setListItems]             = useState(props.listState !== undefined && props.listState !== null ? props.listState.listItems : []);

    // FILTERS
    const [collapsed, setCollapsed] = useState(true);
    const [dataFilter, setDataFilter] = useState({
        fbDataBase : {  id : fbDataBaseId },
        item : {
            categoryProdct : null,
        }
    });

    useEffect(() => {
        if (props.listState === undefined || props.listState === null)
            refreshDataList(page, currentIndex, sizePerPage, dataFilter);
    }, []);

    const handleTableChange = (type, tableChangeParams) => {
        let index = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        refreshDataList(tableChangeParams.page, index, tableChangeParams.sizePerPage, dataFilter);
        setCurrentIndex(index);
        setPage(tableChangeParams.page);
        setSizePerPage(tableChangeParams.sizePerPage);
    };

    const refreshDataList = (_page, _currentIndex, _sizePerPage, _filters) => {
        setLoading(true);

        salesPackageService.search(_currentIndex, _sizePerPage, _filters)
            .then(result => {
                if (result){
                    setListItems(result?.data);
                    setTotalSize(result?.total);
                } else {
                    setListItems([]);
                    setTotalSize(0);
                    setCurrentIndex(0);
                    setPage(1);
                    setSizePerPage(10);
                }
                setLoading(false);
            })
            .catch(errorMessage => {
                setLoading(false);
                setListItems([]);
                setTotalSize(0);
                setCurrentIndex(0);
                setPage(1);
                setSizePerPage(10);
                showToastCustom(error, errorMessage);
            });
    }

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => {
                return (
                    <div className='custom-ui'>
                        <h1>{ARE_YOU_SHURE_TITLE}</h1>
                        <p>{ARE_YOU_SHURE_MSG}</p>
                        <button onClick={onClose}>{NO}</button>
                        <button className={"btn-alert-delete"} onClick={() => {
                            deleteItem(data)
                            onClose();
                        }}>
                            {YES}
                        </button>
                    </div>
                );
            }
        });
    };

    const deleteItem = (data) => {
        setLoading(true);
        salesPackageService.deleteItem(data.id)
            .then(_ => {
                setLoading(false);
                refreshDataList(page, currentIndex, sizePerPage, dataFilter);
                if (utilHelper.hasAssociateRecords()) {
                    showToastCustom(error, deleteErrorMsg, true);
                    utilHelper.restartAssociateRecords();
                } else {
                    showToastCustom(warning, deleteMsg, true);
                }
            });
    }


    // ----------------------------------------------
    //            FORM BEHAVIOR
    // ----------------------------------------------
    const editItem = (data) => {
        props.setListState({
            dataFilter,
            sizePerPage,
            page,
            currentIndex,
            totalSize,
            listItems
        });
        const itemToEdit = listItems.find(n => n.id === data.id);
        props.setForm(true, itemToEdit, 'FORM');
    }

    const showFilters = () => {
        setCollapsed(!collapsed);
    }

    const refreshFiltered = (_dataFilter) => {
        setDataFilter(_dataFilter);
        refreshDataList(page, currentIndex, sizePerPage, _dataFilter);
    }

    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------
    const actionsFormatter = (cell, row) => {
        return (
            <div className="float-left">
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
            </div>
        );
    }

    const columns = [{
        dataField: 'id',
        text: 'ID',
        headerStyle: {width: '0px'},
        hidden: true
    }, {
        dataField: 'uid',
        text: 'UID'
    }, {
        dataField: 'name',
        text: 'Nombre'
    }, {
        dataField: 'packageId',
        text: 'Id de paquete',
        headerStyle: {width: '120px'},
    }, {
        dataField: 'count',
        text: "Cantidad",
        headerStyle: {width: '120px'},
    }, {
        dataField: 'categoryProductCode',
        text: "Categoria del producto",
        headerStyle: {width: '120px'},
    }, {
        isDummyField: true,
        text: 'Acción',
        headerStyle: {width: '140px'},
        formatter: actionsFormatter
    }
    ];

    return (
        <div>
            {loading && showLoader()}
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                    <div className="float-right">
                        <ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
                    </div>
                </CardTitle>
                <Collapse isOpen={collapsed}>
                    <SalesPackageFilters refreshFiltered={refreshFiltered} app={props.app} dataFilter={dataFilter} />
                </Collapse>
                <CardBody className="">
                    <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        data={listItems}
                        columns={columns}
                        noDataIndication={NO_DATA_FOUND}
                        pagination={paginationFactory({page, sizePerPage, totalSize})}
                        onTableChange={handleTableChange}
                    />
                </CardBody>
            </Card>
        </div>
    )
}